import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Entitytag } from '@src/app/models/entitytag';
import { Filtertag } from '@src/app/models/filtertag';
import { Tag } from '@src/app/models/tag';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TagfilterService {

  constructor(private http:HttpClient) { }
  
  //GET	    /person/{personId}/tagfilter/list/type/{tagtype} 
  getFilterTags(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Filtertag[]>(environment.apiUrl+'/person/'+SessionHelper.getUserSub()+'/tagfilter/list',httpOptions);
  }

    //GET	    /organization/{organizationId}/tag/list/type/{tagtype}
    getTags(){
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
      return this.http.get<Tag[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/tag/list',httpOptions);
    }

  // PUT	    /person/{personId}/tagfilter/{tagId}/type/{tagtype} 
  addTagToFilter(tag:Tag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<string>(environment.apiUrl+'/person/'+SessionHelper.getUserSub()+'/tagfilter/'+tag.tagId+'/type/'+tag.tagtype,tag,httpOptions);
  }

   //DELETE	/person/{personId}/tagfilter/{tagId}/type/{tagtype} 
   removeTagFromFilter(etag:Filtertag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/person/'+etag.personId+'/tagfilter/'+etag.tagId+'/type/'+etag.tagtype,httpOptions);
  }
   //Add new tag
  //POST	    /organization/{organizationId}/tag
  saveTag(tag:Tag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<string>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/tag',tag,httpOptions);
  }
    //GET	    /entity/{entityId}/entitytag/list/type/{tagtype}
    getEntityTags(entityId:string,tagtype:string){
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
      return this.http.get<Entitytag[]>(environment.apiUrl+'/entity/'+entityId+'/entitytag/list/type/'+tagtype,httpOptions);
    }
}
